'use client';

import '@ui5/webcomponents/dist/CardHeader.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `CardHeader` is a component, meant to be used as a header of the `Card` component. It displays valuable information, that can be defined with several properties, such as: `titleText`, `subtitleText`, `status` and two slots: `avatar` and `action`.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-Card)
 */
const CardHeader = withWebComponent('ui5-card-header', ['status', 'subtitleText', 'titleText'], ['interactive'], ['action', 'avatar'], ['click']);
CardHeader.displayName = 'CardHeader';
export { CardHeader };